// views/Dashboard/DashboardLayout.tsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PainelExecutivoDashboard from './PainelExecutivo';

const DashboardLayout: React.FC = () => {
  return (
    <div className="w-full max-w-[1600px] mx-auto">
      <Routes>
        {/* `/*`: o painel tem rotas próprias, uma por área (ver PainelExecutivo/index.tsx).
            A casca fica montada ao trocar de área, então os filtros não se perdem. */}
        <Route path="painel-executivo/*" element={<PainelExecutivoDashboard />} />
      </Routes>
    </div>
  );
};

export default DashboardLayout;
